import { render, staticRenderFns } from "./EventPeople.vue?vue&type=template&id=5666154a&"
import script from "./EventPeople.vue?vue&type=script&lang=js&"
export * from "./EventPeople.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports